import {createFileRoute} from '@tanstack/react-router';

import EncounterList from '@/patient/views/EncounterList';

export const Route = createFileRoute('/(patient)/encounters')({
  component: EncounterList
});
